// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2jluD","productName":"Table_productName__3Mk6o"};